<template>
  <div class="home-banner" v-if="imglst && imglst.length > 0">
    <van-swipe class="my-swipe" :autoplay="2500" indicator-color="white">
      <van-swipe-item v-for="(item,index) in imglst" :key="index">
        <img :src="item.url" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
    
    <script>
    import { Toast } from "vant";
export default {
  name: "HomeBannerView",
  data(){
    return  {
      imglst:[]
    }
  },
  created(){
    this.getbanner()
  },
  methods:{
    getbanner() {
      this.$http({
        method: "get",
        url: "getbanner",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
           this.imglst = res.data.banners
          }
        } else {
          Toast(res.msg);
        }
      });
    },
  }
};
</script>
  <style scoped>
.home-banner {
  width: 98%;
  margin: 10px auto 0;
}
.my-swipe .van-swipe-item {
  text-align: center;
}
.my-swipe .van-swipe-item img {
  width: 100%;
  height: 180px;
  border-radius: 8px;
}
</style>
  